"use strict";

var filter = require("./filter.js");

module.exports = filter(a => a);